import React from 'react'

import Tickets from "../../sections/Ticket"

export const Task = () => {
  return (
  <Tickets/>
  )
}